"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.darkTheme = void 0;
const light_1 = require("./light");
const g = (shade, opacity = 1) => {
    const g = 255 - Math.round(255 * shade);
    return `rgba(${g},${g},${g},${opacity})`;
};
exports.darkTheme = {
    ...light_1.lightTheme,
    isLight: false,
    name: 'dark',
    bg: '#1A1A1B',
    color: {
        ...light_1.lightTheme.color,
        ui: {
            lightLine: g(0.1, 0.04),
            line: g(0.1, 0.08),
            lineDark: g(0.1, 0.16),
        },
    },
    g,
};
